import React, { Suspense } from 'react';
import { Switch } from 'react-router-dom';

// routes config
import PrivateRoute from '../routes/PrivateRoute';
import useRoutes from '../routes/userRoutes';

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

const TheContent = () => {
  const [routesList] = useRoutes();

  return (
    <Suspense fallback={loading}>
      <Switch>
        {routesList.map((route, idx) => {
          return (
            route.component && (
              <PrivateRoute
                key={idx}
                path={route.path}
                exact={route.exact}
                name={route.name}
                viewable={route.viewable}
                component={route.component}
              />
            )
          );
        })}
      </Switch>
    </Suspense>
  );
};

export default React.memo(TheContent);
